/**
 * 室內設計服務中心 API Service（Sprint 0：DWG 估價測試）
 * axios 攔截器自動帶 txn_token，Service 層不需手動傳遞。
 */
import axiosInstance from '../api/axios';

const BASE = '/api/ee/interior-design';

export interface QuoteItem {
  category: string;
  cat_name: string;
  layer: string;
  matched: string;
  budget_name: string;
  qty: number;
  unit: string;
  method: string;
  formula: string;
}

export interface DwgUploadResponse {
  session_id: number;
  items_count: number;
}

export interface DwgSessionPreview {
  meta: { session_id: number; items_count: number; parse_warnings?: string | null };
  items: QuoteItem[];
}

/** 上傳 DWG / DXF → 轉檔 + 解析 + 套規則，回 {session_id, items_count}
 *  ⚠️ 必帶 Content-Type: multipart/form-data override：axiosInstance 預設
 *  application/json（src/api/axios.ts），不覆蓋會把 FormData 當 JSON serialize、
 *  boundary 不寫入 → 後端收到空 FormData → 422/500。對齊 opsCenterService upload pattern。 */
export const uploadDwg = async (file: File): Promise<DwgUploadResponse> => {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axiosInstance.post<DwgUploadResponse>(
    `${BASE}/dwg-test/upload`,
    fd,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120_000,   // dwg2dxf 大檔轉檔保險（WASIR 1.3MB 實測 < 5s）
    },
  );
  return res.data;
};

/** 取估價結果（DataGrid/Table 用） */
export const getDwgPreview = async (sessionId: number): Promise<DwgSessionPreview> => {
  const res = await axiosInstance.get<DwgSessionPreview>(`${BASE}/dwg-test/${sessionId}/preview`);
  return res.data;
};

/** 下載多 sheet Excel（瀏覽器觸發下載） */
export const downloadDwgExcel = async (sessionId: number): Promise<void> => {
  const res = await axiosInstance.get(`${BASE}/dwg-test/${sessionId}/export.xlsx`, {
    responseType: 'blob',
  });
  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `dwg_quote_${sessionId}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
